import React from 'react'

import CategoryTitle from '@src/components/CategoryTitle'
import InfiniteScroll from '@src/components/InfiniteScroll'
import Layout from '@src/components/Layout'
import Request from '@src/components/Request'
import { Article } from '@models/Article'

import * as style from './style.module.sass'

export type CategoryLayoutProps = {
  articles: Article[]
  category: string
  subTitle?: string
  displaysCategoryInArticleList?: boolean
  displaysRequestButton?: boolean
}

const CategoryLayout: React.FC<CategoryLayoutProps> = ({
  articles,
  category,
  subTitle,
  displaysCategoryInArticleList,
  displaysRequestButton,
}) => {
  const title = category.toUpperCase()

  return (
    <Layout>
      <div className={style.wrapper}>
        <CategoryTitle title={title} subTitle={subTitle} />

        {articles.length > 0 ? (
          <InfiniteScroll
            articles={articles}
            gtmClickType="category"
            gtmLabel={category}
            displaysCategoryInArticleList={displaysCategoryInArticleList}
          />
        ) : (
          <p className={style.coming}>Coming soon...</p>
        )}

        {displaysRequestButton && (
          <div className={style.request}>
            <Request isWhite />
          </div>
        )}
      </div>
    </Layout>
  )
}

export default CategoryLayout
